export default __webpack_public_path__ + "media/images/pencil_disabled_old-16718f2afddf66eb0877e47b512a6c41.png";